var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassifierLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "url(#paint0_linear_1001_10034)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3051 17.0409C27.7436 16.8267 28.2564 16.8267 28.6949 17.0409L39.0834 22.1147L28.7467 27.6427C28.2802 27.8922 27.7198 27.8922 27.2533 27.6427L16.9166 22.1147L27.3051 17.0409Z",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5417 25.078L39.0834 27.7846L28.7467 33.3127C28.2802 33.5622 27.7198 33.5622 27.2533 33.3127L16.9166 27.7846L22.4583 25.078",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5417 30.7479L39.0834 33.4545L28.7467 38.9826C28.2802 39.2321 27.7198 39.2321 27.2533 38.9826L16.9166 33.4545L22.4583 30.7479",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1001_10034",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassifierLogo);
export default __webpack_public_path__ + "static/media/classifier-logo.b30ab979997a23f32552cd08c8042d50.svg";
export { ForwardRef as ReactComponent };